import { updateUserDepositBonusSettings } from '@/api/auth';
import {
  depositBonusSettingsPatch,
  type DepositBonusSettings,
} from '@/domain/bonuses';
import { publishNewDepositBonusToast } from './deposit-bonus-notifications';

/** Shared by player-socket and lost-bonus claim (legacy `UpdateBonusSettings`). */
export function applyDepositBonusSettingsMessage(
  settings: DepositBonusSettings | null | undefined,
): void {
  const patch = depositBonusSettingsPatch(settings);
  if (!patch) return;
  updateUserDepositBonusSettings({
    ...(patch.SportsbookBonus !== undefined
      ? { SportsbookBonus: patch.SportsbookBonus }
      : {}),
    ...(patch.CasinoBonus !== undefined ? { CasinoBonus: patch.CasinoBonus } : {}),
  });
  if (patch.isNewActive) {
    publishNewDepositBonusToast(settings?.Name);
  }
}
